// Emotion styled components for IDE-style stack trace with light theme
import styled from "@emotion/styled";

// Emotion styled components for IDE-style stack trace with light theme
const StackTraceContainer = styled.div`
  background-color: #ffffff;
  border: 1px solid #e57373;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 1.5rem;
  font-family: "Monaco", "Menlo", "Ubuntu Mono", "Consolas", "SF Mono",
    monospace;
  font-size: 13px;
  line-height: 1.6;
  box-shadow: 0 2px 4px rgba(229, 115, 115, 0.15);
  overflow-x: auto;
`;

const StackTraceHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
`;

const ExceptionCode = styled.code`
  background: #fff3e0;
  color: #e65100;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  border: 1px solid #ffcc80;
  font-family: "Monaco", "Menlo", "Ubuntu Mono", "Consolas", monospace;
`;

const PackagePath = styled.div`
  opacity: 0.7;
  font-size: 11px;
`;

const ExceptionName = styled.div`
  font-size: 13px;
  font-weight: 700;
`;

const ExceptionLabel = styled.span`
  color: #c62828;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  font-family: "Monaco", "Menlo", monospace;
`;

const StackTraceContent = styled.div`
  color: #212121;
`;

const StackTraceLine = styled.div`
  padding: 4px 0;
  white-space: pre-wrap;
  word-break: break-all;

  .at {
    color: #666666;
    margin-right: 8px;
    font-style: italic;
  }

  .method {
    color: #0d47a1;
    font-weight: 600;
  }

  .location {
    color: #424242;
    margin-left: 8px;
    font-weight: 800;
  }

  .line-number {
    color: #2e7d32;
    font-weight: 800;
  }
`;

const HealedLocatorLine = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #ffcdd2;

  .healed-label {
    color: #00695c;
    margin-right: 8px;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.5px;
  }

  .healed-value {
    color: #1a1a1a;
    background-color: #e0f2f1;
    padding: 3px 8px;
    border-radius: 4px;
    font-family: "Monaco", "Menlo", monospace;
    font-size: 12px;
    border: 1px solid #b2dfdb;
    margin-right: 16px;
  }
`;

const StackTraceFullPath = styled.div`
  margin-top: 8px;
  font-size: 12px;

  .path-label {
    color: #757575;
    margin-right: 6px;
    font-weight: 500;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.5px;
  }

  .path-value {
    color: #333333;
    word-break: break-all;
    background-color: #f5f5f5;
    padding: 3px 8px;
    border-radius: 4px;
    font-family: "Monaco", "Menlo", monospace;
    border: 1px solid #e0e0e0;
  }
`;

const ExceptionMessage = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #ffcdd2;

  .message-label {
    color: #b71c1c;
    margin-right: 8px;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.5px;
  }

  .message-value {
    color: #1a1a1a;
    line-height: 1.5;
    margin-top: 4px;
    display: block;
    background-color: #ffffff;
    padding: 10px 14px;
    border-radius: 4px;
    border-left: 4px solid #ef5350;
    border-top: 1px solid #ffebee;
    border-right: 1px solid #ffebee;
    border-bottom: 1px solid #ffebee;
    font-size: 13px;
  }
`;

const ChartsWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;


export {
  StackTraceContainer,
  StackTraceHeader,
  StackTraceContent,
  StackTraceLine,
  HealedLocatorLine,
  StackTraceFullPath,
  ExceptionMessage,
  ExceptionLabel,
  PackagePath,
  ExceptionCode,
  ExceptionName,
  ChartsWrapper,
};
